// extracted by mini-css-extract-plugin
export var messageSideLeft = "_r0-1";
export var stateContainer = "_r0-0";